/**
 * Made-up calls and outbound updates for the lead page's Calls and Messages tabs,
 * until calls (CALL-1…4, V2) and messaging (OUT-1…6) exist. They are built from the
 * lead, so every lead tells a plausible story, and the page marks them with a DemoPill.
 */
import { leadTitle, shownEmail } from '@/utils/format';

import { MOCK_STAFF } from './shared';

export type MockCall = {
  id: string;
  title: string;
  at: string;
  minutes: number;
  people: string[];
  /** How the call was matched to the lead (CALL-2). */
  linkedBy: string;
  /** The note taker's summary (CALL-4, V2). */
  notes: string;
};

export type MockChannel = 'email' | 'telegram' | 'popup';

type LeadLike = { email: string; full_name: string; created_at: string; stage: string; chats: unknown[] };

const after = (iso: string, days: number) => new Date(new Date(iso).getTime() + days * 86_400_000).toISOString();
const past = <T extends { at?: string; sentAt?: string }>(items: T[]) =>
  items.filter((i) => new Date((i.at ?? i.sentAt) as string).getTime() <= Date.now());

export const mockCalls = (lead: LeadLike): MockCall[] => {
  const email = shownEmail(lead.email);
  const who = leadTitle(lead.full_name, lead.email);
  const local = email.split('@')[0] || 'guest';
  return past([
    {
      id: 'call-2',
      title: 'Setup walkthrough',
      at: after(lead.created_at, 9),
      minutes: 40,
      people: [who, MOCK_STAFF[0].name],
      linkedBy: `Joined as ${local}.work@example.com; matched to this lead by name and the Telegram group.`,
      notes: 'Went through the domain and payment steps. Open: the license documents. Next step: a check-in after launch.',
    },
    {
      id: 'call-1',
      title: 'Intro call',
      at: after(lead.created_at, 2),
      minutes: 25,
      people: [who, MOCK_STAFF[1].name],
      linkedBy: `Calendar invite sent to ${email || 'the lead'}.`,
      notes: 'Wants to launch within three months. Asked about the license, payment methods and timelines.',
    },
  ]);
};

